import { render, staticRenderFns } from "./feedback-table-item.vue?vue&type=template&id=401fd160&scoped=true"
import script from "./feedback-table-item.vue?vue&type=script&lang=js"
export * from "./feedback-table-item.vue?vue&type=script&lang=js"
import style0 from "./feedback-table-item.vue?vue&type=style&index=0&id=401fd160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401fd160",
  null
  
)

export default component.exports